import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    visible: false,
    allJokes: []
  },
  mutations: {
    // sync
    setVisibility (state, payload) {
      state.visible = payload
    }
  },
  actions: {
    async doSomething () {
      const url = 'https://example.com'
      const headers = 'Content-Type: application/json'
      const x = await fetch(url, { headers })
      const j = await x.json()
      this.state.commit('setSomething', j.x)
    }
  },
  modules: {},
  getters: {
    getVisibility: state => state.visible,
    getAllJokes: state => state.allJokes
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js